import Routers from './router'
import systemStore from './store'
export default{
	install(Vue,{router,store}){
		router.addRoute(Routers);
		store.registerModule('systemModule', systemStore)
	}
}